import { Box, Card, Grid, TextField, Button, MenuItem } from '@mui/material';
import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { apiput } from '../../service/api';
import { SectionCard, SectionHeader, FieldRow } from './LeadViewStyles';

const LeadTracking = ({ data, setUserAction }) => {
  const [formData, setFormData] = useState({ ...data });
  const [isEdited, setIsEdited] = useState(false);

  useEffect(() => {
    setFormData({ ...data });
  }, [data]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    setIsEdited(true);
  };

  const handleSave = async () => {
    const result = await apiput(`lead/edit/${data._id}`, formData);
    setUserAction(result);
    if (result.status === 200) {
      toast.success('Lead information updated successfully!');
      setIsEdited(false);
    } else {
      toast.error('Failed to update lead information.');
    }
  };

  return (
    <div>
      <Card style={{ borderTopLeftRadius: "0px", borderTopRightRadius: "0px" }}>
        <Box p={3}>
          {/* Lead Assignment */}
          <SectionCard>
            <SectionHeader>Lead Assignment</SectionHeader>
            <FieldRow>
              <Grid item xs={12} sm={4}>
                <TextField
                  label="Lead Assigned To"
                  name="leadAssignedTo"
                  value={formData.leadAssignedTo || ''}
                  fullWidth
                  margin="dense"
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  label="LASSO Record #"
                  name="lassoRecordNumber"
                  value={formData.lassoRecordNumber || ''}
                  fullWidth
                  margin="dense"
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  label="Lead Status"
                  name="leadStatus"
                  value={formData.leadStatus || ''}
                  fullWidth
                  margin="dense"
                  onChange={handleChange}
                  select
                >
                  <MenuItem value="Call 1 - Not Interested">Call 1 - Not Interested</MenuItem>
                  <MenuItem value="Call 1 - No Answer">Call 1 - No Answer</MenuItem>
                  <MenuItem value="Call 1 - Left Message">Call 1 - Left Message</MenuItem>
                  <MenuItem value="Call 2 - Not Interested">Call 2 - Not Interested</MenuItem>
                  <MenuItem value="Call 2 - No Answer">Call 2 - No Answer</MenuItem>
                  <MenuItem value="Call 2 - Left Message">Call 2 - Left Message</MenuItem>
                  <MenuItem value="Application Pending">Application Pending</MenuItem>
                  <MenuItem value="Application Received">Application Received</MenuItem>
                  <MenuItem value="Pre-Approved - Active Shop...">Pre-Approved - Active Shop...</MenuItem>
                  <MenuItem value="Pre-Approved - Under Contr...">Pre-Approved - Under Contr...</MenuItem>
                  <MenuItem value="Dead Lead">Dead Lead</MenuItem>
                  <MenuItem value="Not Interested">Not Interested</MenuItem>
                  <MenuItem value="Campaign - FHA Streamline ...">Campaign - FHA Streamline ...</MenuItem>
                  <MenuItem value="Campaign - VA IRRRL Alert">Campaign - VA IRRRL Alert</MenuItem>
                  <MenuItem value="Campaign - Monthly Touchbase">Campaign - Monthly Touchbase</MenuItem>
                  <MenuItem value="Campaign - Quarterly Check...">Campaign - Quarterly Check...</MenuItem>
                  <MenuItem value="New">New</MenuItem>
                  <MenuItem value="Contacted">Contacted</MenuItem>
                  <MenuItem value="Qualified">Qualified</MenuItem>
                  <MenuItem value="Not Qualified">Not Qualified</MenuItem>
                  <MenuItem value="Closed/Won">Closed/Won</MenuItem>
                  <MenuItem value="Closed/Lost">Closed/Lost</MenuItem>
                  <MenuItem value="Follow-up Required">Follow-up Required</MenuItem>
                  <MenuItem value="On Hold">On Hold</MenuItem>
                  <MenuItem value="Converted">Converted</MenuItem>
                  <MenuItem value="Credit Repair">Credit Repair</MenuItem>
                </TextField>
              </Grid>
            </FieldRow>
          </SectionCard>

          {/* Contact Attempts - horizontal rows */}
          <SectionCard>
            <SectionHeader>Contact Attempts</SectionHeader>
            {/* Contact 1 */}
            <FieldRow sx={{ mb: 1 }}>
              <Grid item xs={12} sm={4}>
                <TextField
                  label="Contact Date 1"
                  name="contactDate1"
                  value={formData.contactDate1 || ''}
                  fullWidth
                  margin="dense"
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  label="Contact 1 Results"
                  name="contactResults1"
                  value={formData.contactResults1 || ''}
                  fullWidth
                  margin="dense"
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  label="Contact 1 Type"
                  name="contactType1"
                  value={formData.contactType1 || ''}
                  fullWidth
                  margin="dense"
                  onChange={handleChange}
                />
              </Grid>
            </FieldRow>
            {/* Contact 2 */}
            <FieldRow sx={{ mb: 1 }}>
              <Grid item xs={12} sm={4}>
                <TextField
                  label="Contact Date 2"
                  name="contactDate2"
                  value={formData.contactDate2 || ''}
                  fullWidth
                  margin="dense"
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  label="Contact 2 Results"
                  name="contactResults2"
                  value={formData.contactResults2 || ''}
                  fullWidth
                  margin="dense"
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  label="Contact 2 Type"
                  name="contactType2"
                  value={formData.contactType2 || ''}
                  fullWidth
                  margin="dense"
                  onChange={handleChange}
                />
              </Grid>
            </FieldRow>
            {/* Contact 3 */}
            <FieldRow>
              <Grid item xs={12} sm={4}>
                <TextField
                  label="Contact Date 3"
                  name="contactDate3"
                  value={formData.contactDate3 || ''}
                  fullWidth
                  margin="dense"
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  label="Contact 3 Results"
                  name="contactResults3"
                  value={formData.contactResults3 || ''}
                  fullWidth
                  margin="dense"
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  label="Contact 3 Type"
                  name="contactType3"
                  value={formData.contactType3 || ''}
                  fullWidth
                  margin="dense"
                  onChange={handleChange}
                />
              </Grid>
            </FieldRow>
          </SectionCard>

          {/* Action Taken */}
          <SectionCard>
            <SectionHeader>Action Taken</SectionHeader>
            <FieldRow>
              <Grid item xs={6} sm={3}>
                <TextField
                  label="Preapproved?"
                  name="preApproved"
                  value={formData.preApproved || ''}
                  fullWidth
                  margin="dense"
                  onChange={handleChange}
                  select
                >
                  <MenuItem value="Yes">Yes</MenuItem>
                  <MenuItem value="No">No</MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={6} sm={3}>
                <TextField
                  label="Refi Offer Accepted?"
                  name="refiOfferAccepted"
                  value={formData.refiOfferAccepted || ''}
                  fullWidth
                  margin="dense"
                  onChange={handleChange}
                  select
                >
                  <MenuItem value="Yes">Yes</MenuItem>
                  <MenuItem value="No">No</MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={6} sm={3}>
                <TextField
                  label="Assign Campaign"
                  name="assignCampaign"
                  value={formData.assignCampaign || ''}
                  fullWidth
                  margin="dense"
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={6} sm={3}>
                <TextField
                  label="Campaign Last Sent Date"
                  name="campaignLastSentDate"
                  value={formData.campaignLastSentDate || ''}
                  fullWidth
                  margin="dense"
                  onChange={handleChange}
                />
              </Grid>
            </FieldRow>
          </SectionCard>

          {/* Authorization */}
          <SectionCard>
            <SectionHeader>Authorization</SectionHeader>
            <FieldRow>
              <Grid item xs={6} sm={3}>
                <TextField
                  label="Opt-In?"
                  name="optIn"
                  value={formData.optIn || ''}
                  fullWidth
                  margin="dense"
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={6} sm={3}>
                <TextField
                  label="Subscribed?"
                  name="subscribed"
                  value={formData.subscribed || ''}
                  fullWidth
                  margin="dense"
                  onChange={handleChange}
                />
              </Grid>
            </FieldRow>
          </SectionCard>

          {/* Notes */}
          <SectionCard>
            <SectionHeader>Notes</SectionHeader>
            <TextField
              label="Helpful Information"
              name="helpfulInfo"
              value={formData.helpfulInfo || ''}
              fullWidth
              margin="dense"
              multiline
              rows={4}
              onChange={handleChange}
            />
          </SectionCard>

          {/* Save Button */}
          <Box display="flex" justifyContent="flex-end" mt={1}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleSave}
              disabled={!isEdited}
            >
              Save
            </Button>
          </Box>
        </Box>
      </Card>
    </div>
  );
};

export default LeadTracking;
